var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8045 18.8619L15.2545 14.3119C16.1359 13.2233 16.6665 11.8399 16.6665 10.3333C16.6665 6.84132 13.8252 4 10.3333 4C6.84128 4 4 6.84128 4 10.3333C4 13.8252 6.84132 16.6665 10.3333 16.6665C11.8399 16.6665 13.2233 16.1359 14.3119 15.2545L18.8619 19.8045C18.9919 19.9345 19.1625 19.9998 19.3332 19.9998C19.5039 19.9998 19.6745 19.9345 19.8045 19.8045C20.0652 19.5438 20.0652 19.1225 19.8045 18.8619ZM10.3333 15.3332C7.57597 15.3332 5.33333 13.0906 5.33333 10.3333C5.33333 7.57593 7.57597 5.3333 10.3333 5.3333C13.0906 5.3333 15.3332 7.57593 15.3332 10.3333C15.3332 13.0906 13.0906 15.3332 10.3333 15.3332Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2c6c622afd853ccb59b686012aee84ef.svg";
export { ForwardRef as ReactComponent };